const sectionId = document.querySelector('.quantity').getAttribute('data-section-id');
const productId = document.querySelector('.quantity').getAttribute('data-product-id');
const chargeCheckboxes = document.querySelectorAll('.product__custom-option-checkbox');
const charactersInputField = document.querySelector('.characters__input');
const quantityInput = document.querySelector(`#Quantity-${sectionId}-${productId}`);

const subtotal = document.querySelector('.product__subtotal-price-value');
const subtotalDataPrice = subtotal.getAttribute('data-price');
let floatSubtotal = parseFloat(subtotalDataPrice) / 100;

let currentMaterial;

initializeCharacterInput();
initializeMaterialOptions();

function initializeCharacterInput() {
    if (!subtotal) {
        console.warn('Subtotal element not found');
        return;
    }

    if (quantityInput.value !== '0') {
        subtotal.innerText = floatSubtotal.toFixed(2);
    }

    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
        floatSubtotal = event.data.variant.price / 100;
        syncQuantityAndSubtotal();
    });

    if (charactersInputField && quantityInput) {
        charactersInputField.addEventListener('input', syncQuantityAndSubtotal);

        chargeCheckboxes.forEach((checkbox) => {
            checkbox.addEventListener('change', syncQuantityAndSubtotal);
        });

        syncQuantityAndSubtotal();
    } else {
        console.error('One or more elements not found in the DOM.');
    }

    /**
     * Always recompute from current text length + checked increments
     * so quantity cannot drift across toggles/edits.
     */
    function getCharacterCount() {
        const textLength = charactersInputField ? charactersInputField.value.length : 0;
        let incrementTotal = 0;

        chargeCheckboxes.forEach((checkbox) => {
            if (!checkbox.checked) return;

            // Missing/invalid values fall back to 2 (historical single-checkbox behavior).
            const parsed = Number.parseInt(checkbox.dataset.quantityIncrement, 10);
            const increment = Number.isFinite(parsed) ? Math.max(0, parsed) : 2;
            incrementTotal += increment;
        });

        return textLength + incrementTotal;
    }

    function syncQuantityAndSubtotal() {
        const characterCount = getCharacterCount();
        updateQuantityAndSubtotal(characterCount, floatSubtotal);
    }

    function updateQuantityAndSubtotal(characterCount, productPrice) {
        const sanitizedCount = Math.max(0, Math.floor(characterCount));
        quantityInput.value = sanitizedCount;

        updateSubtotalValue(sanitizedCount, productPrice);
    }

    /**
     * Updates the subtotal based on the provided count and price.
     * @param {number} characterCount - The quantity of the product.
     * @param {number} productPrice - The unit price of the product.
     */
    function updateSubtotalValue(characterCount, productPrice) {
        const calculatedSubtotal = characterCount * productPrice;
        const formattedSubtotal = calculatedSubtotal.toFixed(2);
        subtotal.innerText = formattedSubtotal;
    }
}

function initializeMaterialOptions() {
    // Hide some Height values based on materials.
    const initialMaterialSelect = document.querySelector("[name='options[MATERIAL]']");
    const heightSelect = document.querySelector("[name='options[HEIGHT]']");

    if (!heightSelect) {
        console.error("Height select element not found.");
        return;
    }

    const heightOptions = Array.from(heightSelect.querySelectorAll("option"));

    if (initialMaterialSelect) {
        currentMaterial = initialMaterialSelect.value;
    } else if (document.querySelector("[data-product-template]")) {
        currentMaterial = document.querySelector("[data-product-template]").getAttribute("data-product-template");
        currentMaterial = currentMaterial.charAt(0).toUpperCase() + currentMaterial.slice(1);
        return;
    } else {
        console.error("MATERIAL select element not found.");
        return;
    }

    if (currentMaterial !== "Sticker") {
        hideStickHeights(heightOptions);
    }

    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
        const selectedMaterial = event.data.variant.option1;
        const heightSelect = document.querySelector("[name='options[HEIGHT]']");

        handleMaterialChange(selectedMaterial, heightSelect);
    });
}

function handleMaterialChange(selectedMaterial, heightSelect) {
    const heightOptions = Array.from(heightSelect.querySelectorAll("option"));

    if ((currentMaterial !== "Sticker" && selectedMaterial === "Sticker") || (currentMaterial === "Sticker" && selectedMaterial === "Sticker")) {
        console.log("All height options are now visible");
    } else if (currentMaterial === "Sticker" && selectedMaterial !== "Sticker") {
        hideStickHeights(heightOptions);
        // selectFirstAvailableHeight(heightOptions);
    } else {
        hideStickHeights(heightOptions);
    }
    currentMaterial = selectedMaterial;
}

function hideStickHeights(heightOptions) {
    heightOptions.forEach((option) => {
        if (!option) {
            console.error("Height option not found.");
            return;
        }

        if (option.value.includes("sticker")) {
            option.hidden = true;
            option.disabled = true;
        } else {
            option.hidden = false;
            option.disabled = false;
        }
    });
}

// function selectFirstAvailableHeight(heightOptions) {
//     const firstVisibleHeight = heightOptions.find(option => !option.hidden);
//     if (firstVisibleHeight) {
//         firstVisibleHeight.selected = true;
//     } else {
//         heightOptions.forEach(option => {
//             option.selected = false;
//         });
//     }
// }
